let eventGuid = 0;
// let todayStr = new Date().toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
  {
    id: 0,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-10-03",
    end: "2023-10-13",
    status: "done",
    backgroundColor: "rgba(198, 240, 240, 0.43)",
    isSmall: true,
  },
  {
    id: 1,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-10-03",
    end: "2023-10-14",
    status: "active",
    backgroundColor: "rgba(234, 231, 249, 0.64)",
    isSmall: true,
  },
  {
    id: 2,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-10-03",
    end: "2023-10-12",
    status: "coming",
    backgroundColor: "rgba(228, 228, 228, 0.43)",
    isSmall: true,
  },
  {
    id: 3,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-10-03",
    end: "2023-10-11",
    status: "active",
    backgroundColor: "rgba(234, 231, 249, 0.64)",
    isSmall: true,
  },
  {
    id: 4,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-10-15",
    end: "2023-10-23",
    status: "active",
    backgroundColor: "rgba(234, 231, 249, 0.64)",
    isSmall: false,
  },
  {
    id: 5,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-11-02",
    end: "2023-11-12",
    status: "coming",
    backgroundColor: "rgba(228, 228, 228, 0.43)",
    isSmall: false,
  },
  {
    id: 0,
    title: "מכירה פרשת ויקהל",
    subtitle: "מכירה שבועית ",
    start: "2023-11-19",
    end: "2023-11-23",
    status: "done",
    backgroundColor: "rgba(198, 240, 240, 0.43)",
    isSmall: false,
  },
];

// export function createEventId() {
//   return String(eventGuid++);
// }
